import Cookies from 'js-cookie';

export const SelectedOrganizationIdCookie = 'selectedOrganizationId';

export const getSelectedOrganizationId = () => Cookies.get(SelectedOrganizationIdCookie);
